import { render, staticRenderFns } from "./UIpause.vue?vue&type=template&id=f71b5120&scoped=true&"
import script from "./UIpause.vue?vue&type=script&lang=js&"
export * from "./UIpause.vue?vue&type=script&lang=js&"
import style0 from "./UIpause.vue?vue&type=style&index=0&id=f71b5120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71b5120",
  null
  
)

export default component.exports